import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from "react-bootstrap";
import CrossIcon from "assets/img/file-cut-icon.png";

export function ConfirmAccStatusModal({ show, canEdit, onHide, onConfirm, title, message }) {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
                <button onClick={onHide} className="modal-close">
                    <img src={CrossIcon} alt="Close" style={{ width: "20px", height: "20px" }} />
                </button>
            </Modal.Header>
            <Modal.Body>
                <p>{message}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="cancel-cta"
                    style={{ color: "white" }}
                    onClick={onHide}
                >
                    Cancel
                </Button>
                <Button
                    variant="update-cta"
                    style={{ backgroundColor: "red", color: "white" }}
                    onClick={onConfirm}
                    disabled={!canEdit}
                >
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

ConfirmAccStatusModal.propTypes = {
    show: PropTypes.bool.isRequired,
    canEdit: PropTypes.bool,
    onHide: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string,
    message: PropTypes.string,
};
ConfirmAccStatusModal.defaultProps = {
    canEdit: false
};